import { inputCls } from "../../admin/ui";

export const DateRange = ({ start, end, onChange, testid = "date-range", dark = true }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
    <input type="date" value={start} max={end || undefined} onChange={(e) => onChange({ start: e.target.value, end })}
      className={`${inputCls} !w-auto ${dark ? "[color-scheme:dark]" : ""}`} data-testid={`${testid}-start`} aria-label="Start date" />
    <span className="text-xs text-zinc-500">to</span>
    <input type="date" value={end} min={start || undefined} onChange={(e) => onChange({ start, end: e.target.value })}
      className={`${inputCls} !w-auto ${dark ? "[color-scheme:dark]" : ""}`} data-testid={`${testid}-end`} aria-label="End date" />
    {(start || end) && (
      <button onClick={() => onChange({ start: "", end: "" })} data-testid={`${testid}-clear`} className="text-xs uppercase tracking-wider text-[#D4AF37] hover:text-[#F3D77A]">Clear</button>
    )}
  </div>
);
